import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState
} from "react";
import moment from "moment-timezone";
import axios from "axios";
import {
    IoNotificationsOutline,
    IoSettingsOutline,
    IoLogOutOutline,
    IoLogoWhatsapp,
} from "react-icons/io5";

import {
    connectToWebSocket,
    sendMessageToSocket,
    getChats,
    getCustomChat,
    getCustomUser,
    getUsers,
    createNotification,
    updateUser,
    updateChat,
    getChatGroupById,
    updateChatGroup,
    getCustomSuperAdmin,
} from "../api";

import "../styles/sifaris.css";
import SubModal from "../components/SubModal";
import TodayOrdersBanner from "../components/TodayOrdersBanner";
import QuickNav from "../components/QuickNav";
import LocationBubble from "../components/LocationBubble";
import EditMessageModal from "../components/EditMessageModal";
import {
    TS_FMT,
    toAzMoment,
    detectPhoneNumber,
    formatPhoneNumberForWhatsApp,
    groupMessagesByDate,
    interleaveChatAds,
} from "../utils/orderGroupHelpers";
import {
    useNavigate
} from "react-router-dom";
import {
    getStableDeviceId
} from "../utils/deviceId"; import {
    Helmet
} from "react-helmet-async";
const CHAT_LIMIT = 30;
const PLACEHOLDER = "https://i.ibb.co/zh9bV6gr/Ads-z-tasar-m-1.png";

const OrderGroupScreen = () => {
    const [currentMessage,
        setCurrentMessage] = useState("");
    const [chatMessages,
        setChatMessages] = useState([]);
    const [userType,
        setUserType] = useState("");
    const [courierType,
        setCourierType] = useState("");
    const [isMuted,
        setIsMuted] = useState(false);
    const [userId,
        setUserId] = useState(null);
    const [username,
        setUsername] = useState("");
    const [editingMessage,
        setEditingMessage] = useState(null);
    const [editedText,
        setEditedText] = useState("");
    const [isUpdating,
        setIsUpdating] = useState(false);
    const [showSub,
        setShowSub] = useState(false);

    const [todayTotalCount,
        setTodayTotalCount] = useState(0)

    const [canClickZinqirov,
        setCanClickZinqirov] = useState(true);
    const [messageModal,
        setMessageModal] = useState( {
            open: false,
            title: "",
            message: "",
            type: "info",
        });

    const [imagePreview,
        setImagePreview] = useState( {
            visible: false,
            uri: null,
        });

    const [switchSuccessModal,
        setSwitchSuccessModal] = useState( {
            open: false,
            message: "",
        });

    const [showQuickNav,
        setShowQuickNav] = useState(true);
    const lastScrollTopRef = useRef(0);
    const scrollTimerRef = useRef(null);

    const [logoutMenuOpen,
        setLogoutMenuOpen] = useState(false);
    const [courierTypeModalOpen,
        setCourierTypeModalOpen] = useState(false);

    const bottomRef = useRef(null);
    const socketReadyRef = useRef(false);
    const navigate = useNavigate();
    const autoCompletedIdsRef = useRef(new Set());
    const sendAudioRef = useRef(null);

    const userCacheRef = useRef(null);
    const groupCacheRef = useRef(null);

    const ONE_SIGNAL_APP_ID = "26a128f2-4ccf-4dde-9986-2b27bb1a25b2";
    const ONE_SIGNAL_REST_API_KEY =
    "os_v2_app_e2qsr4smz5g55gmgfmt3wgrfwlr3fpv76kau37n2xxvu2m2krc6g3wi4dhudjinuajtqdxnsbt5rlnnumq6osxxaalhxyhmzkypia5q";

    const isValidUUID = (s) =>
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
        String(s || "").trim()
    );


    const myPhone = useMemo(
        () => localStorage.getItem("phoneNumber") || "",
        []
    );

    const mergeMessages = useCallback((prev, incomingRaw) => {
        const incoming = Array.isArray(incomingRaw) ? incomingRaw: [incomingRaw];

        const all = [...prev, ...incoming]
        .filter(
            (m) =>
            m &&
            (String(m.groupId) === "0" || String(m.groupId) === "1")
        );

        const map = new Map();

        for (const item of all) {
            map.set(String(item.id), item);
        }

        return Array.from(map.values()).sort((a, b) => {
            const ta = moment(a.timestamp || a.createdAt, TS_FMT, true);
            const tb = moment(b.timestamp || b.createdAt, TS_FMT, true);
            return (ta.isValid() ? ta.valueOf(): 0) - (tb.isValid() ? tb.valueOf(): 0);
        });
    },
        []);

    const safeScrollToBottom = useCallback((smooth = true) => {
        requestAnimationFrame(() => {
            bottomRef.current?.scrollIntoView({
                behavior: smooth ? "smooth": "auto",
                block: "end",
            });
        });
    },
        []);



    const ensureWebSocket = useCallback(() => {
        if (socketReadyRef.current) return;

        socketReadyRef.current = true;

        connectToWebSocket(async (newMessages) => {
            // 1. WebSocket message merge
            setChatMessages((prev) => mergeMessages(prev, newMessages));

            // 2. Auto scroll bottom
            requestAnimationFrame(() => {
                safeScrollToBottom(true);
            });

            // 3. Tab aktivdirsə server sync
            if (!document.hidden) {
                try {
                    const response = await getChats({
                        limit: CHAT_LIMIT,
                        groupIds: "0,1"
                    });

                    const list = Array.isArray(response?.data)
                    ? response.data: [];

                    const chatsGroup01 = list
                    .filter(
                        (c) =>
                        String(c.groupId) === "0" ||
                        String(c.groupId) === "1"
                    )
                    .sort((a, b) => {
                        const ma = moment(a.timestamp || a.createdAt, TS_FMT, true);
                        const mb = moment(b.timestamp || b.createdAt, TS_FMT, true);
                        return (ma.isValid() ? ma.valueOf(): 0) - (mb.isValid() ? mb.valueOf(): 0);
                    });

                    setChatMessages(chatsGroup01);
                } catch (e) {
                    console.error("WebSocket refresh error:", e);
                }
            }
        });

    }, [mergeMessages, safeScrollToBottom]);

    const autoResetSubscriptionIfNeeded = async (uid, u) => {
        try {
            const plan = String(u?.subPlan || u?.planId || u?.plan || "").toLowerCase();
            const isLifetime =
            plan.includes("life") ||
            plan.includes("lifetime") ||
            plan.includes("omurluk");

            if (isLifetime) return;
            if (!u?.isSub) return;

            const now = moment().tz("Asia/Baku");
            const exp = u?.expiryDate
            ? moment.tz(String(u.expiryDate), TS_FMT, "Asia/Baku"): null;

            if (exp && exp.isValid() && !exp.isAfter(now)) {
                await updateUser(uid, {
                    isSub: false, expiryDate: ""
                });
                return;
            }

            const isMonthly1to1 =
            plan.includes("monthly_1to1") ||
            plan.includes("month") ||
            plan.includes("ayliq");

            if (isMonthly1to1 && now.date() === 1) {
                const monthKey = now.format("YYYY-MM");
                const lastKey = localStorage.getItem("subResetMonthKey");

                if (lastKey !== monthKey) {
                    await updateUser(uid, {
                        isSub: false, expiryDate: ""
                    });
                    localStorage.setItem("subResetMonthKey", monthKey);
                }
            }
        } catch (e) {
            console.log("autoResetSubscriptionIfNeeded error:", e?.message);
        }
    };

    const showMessage = ({
        title, message, type = "info"
    }) => {
        setMessageModal({
            open: true,
            title,
            message,
            type,
        });
    };

    const showSwitchSuccess = (message, path = "/sifaris/order-group") => {
        setSwitchSuccessModal({
            open: true,
            message,
            path,
        });
    };

    const hasActiveSubscription = (u) => {
        const plan = String(u?.subPlan || u?.planId || u?.plan || "").toLowerCase();
        const isLifetime =
        plan.includes("life") ||
        plan.includes("lifetime") ||
        plan.includes("omurluk");

        if (isLifetime) return true;
        if (!u?.isSub) return false;
        if (!u?.expiryDate) return false;

        const exp = moment.tz(String(u.expiryDate), TS_FMT, "Asia/Baku");
        const now = moment().tz("Asia/Baku");

        return exp.isValid() && exp.isAfter(now);
    };

    const openImagePreview = (uri) => {
        setImagePreview({
            visible: true, uri
        });
    };

    const closeImagePreview = () => {
        setImagePreview({
            visible: false, uri: null
        });
    };





    const completeIfExpired = useCallback(async (msgs) => {
        try {
            const now = moment().tz("Asia/Baku");

            const candidates = (msgs || []).filter(
                (m) =>
                String(m.groupId) === "0" &&
                !m.isCompleted &&
                (m.timestamp || m.createdAt)
            );

            for (const m of candidates) {
                const tsStr = typeof m.timestamp === "string" ? m.timestamp: m.createdAt;
                const ts = moment.tz(tsStr, TS_FMT, "Asia/Baku");

                if (!ts.isValid()) continue;

                const diffSec = now.diff(ts, "seconds");

                if (diffSec >= 120 && !autoCompletedIdsRef.current.has(m.id)) {
                    autoCompletedIdsRef.current.add(m.id);

                    try {
                        await updateChat(m.id, {
                            ...m, isCompleted: true
                        });

                        setChatMessages((prev) =>
                            prev.map((x) =>
                                x.id === m.id ? {
                                    ...x, isCompleted: true
                                }: x
                            )
                        );
                    } catch (e) {
                        autoCompletedIdsRef.current.delete(m.id);
                        console.error("Auto complete error:", e);
                    }
                }
            }
        } catch (e) {
            console.error("completeIfExpired outer error:", e);
        }
    },
        []);

    const fetchTodayStats = useCallback(async () => {
        try {
            const saResp = await getCustomSuperAdmin(1);
            const count = Number(saResp?.data?.todayChatCount) || 0;
            setTodayTotalCount(count);
        } catch (e) {
            console.log("fetchTodayStats error:", e?.message);
        }
    },
        []);

    const getAllChats = useCallback(async () => {
        try {
            const response = await getChats({
                limit: CHAT_LIMIT, groupIds: "0,1"
            });
            const list = Array.isArray(response?.data) ? response.data: [];
            const chatsGroup01 = list
            .filter((c) => String(c.groupId) === "0" || String(c.groupId) === "1")
            .sort((a, b) => {
                const ma = moment(a.timestamp || a.createdAt, TS_FMT, true);
                const mb = moment(b.timestamp || b.createdAt, TS_FMT, true);
                return (ma.isValid() ? ma.valueOf(): 0) - (mb.isValid() ? mb.valueOf(): 0);
            });
            setChatMessages(chatsGroup01);
            completeIfExpired(chatsGroup01);
            safeScrollToBottom(false);
        } catch (e) {
            console.error("getAllChats error:", e);
        }
    },
        [safeScrollToBottom,
            completeIfExpired]);

    useEffect(() => {
        const initialize = async () => {
            try {
                const storedUserId = localStorage.getItem("id");
                const storedUserType = localStorage.getItem("userType") || "";
                const storedCourierType = localStorage.getItem("courierType") || "";

                setUserId(Number(storedUserId));
                setUserType(storedUserType);
                setCourierType(storedCourierType);

                if (!storedUserId) return;

                const resp = await getCustomUser(storedUserId);
                const u = resp?.data;
                if (!u) return;

                const stableDeviceId = await getStableDeviceId();
                localStorage.setItem("deviceUUID", stableDeviceId);

                const storedPassword = localStorage.getItem("password") || "";

                await autoResetSubscriptionIfNeeded(storedUserId, u);

                try {
                    if (String(u?.hasActiveApp || "") !== "sifarisqrupu") {
                        await updateUser(storedUserId, {
                            hasActiveApp: "sifarisqrupu"
                        });
                    }
                } catch (e) {
                    console.log("hasActiveApp update error:", e?.message);
                }

                try {
                    if (Number(u?.appVersion) !== 26) {
                        await updateUser(storedUserId, {
                            appVersion: 26
                        });
                    }
                } catch (e) {
                    console.log("appVersion update error:", e?.message);
                }

                if (u?.isDisable) {
                    const hasExpiry =
                    u.disableExpiryDate && String(u.disableExpiryDate).trim().length > 0;

                    if (hasExpiry) {
                        const disableExpiryDate = moment(
                            u.disableExpiryDate,
                            "YYYY-MM-DD HH:mm:ss",
                            true
                        );
                        const now = moment();

                        if (disableExpiryDate.isValid() && disableExpiryDate.isBefore(now)) {
                            await updateUser(storedUserId, {
                                isDisable: false,
                                disableExpiryDate: "",
                            });
                            showMessage( {
                                title: "Diqqət",
                                message:
                                "Hesabınızın bloklanma müddəti bitib. Hesabınız aktivləşdirildi.",
                                type: "success",
                            });
                        } else {
                            showMessage( {
                                title: "Diqqət",
                                message: "Hesabınız 24 saatlıq blok edilib. Çıxış edilir...",
                                type: "error",
                            });

                            localStorage.clear();
                            navigate("/sifaris/login", {
                                replace: true
                            });
                            return;
                        }
                    } else {
                        showMessage( {
                            title: "Diqqət",
                            message: "Hesabınız blok edilib. Çıxış edilir...",
                            type: "error",
                        });

                        localStorage.clear();
                        navigate("/sifaris/login", {
                            replace: true
                        });
                        return;
                    }
                }

                if (storedPassword && u.password !== storedPassword) {
                    showMessage( {
                        title: "Diqqət",
                        message: "Şifrəniz dəyişdirilib. Yenidən daxil olun!",
                        type: "warning",
                    });

                    localStorage.clear();
                    navigate("/sifaris/login", {
                        replace: true
                    });
                    return;
                }

                if (u.phoneId && u.phoneId !== stableDeviceId) {
                    showMessage( {
                        title: "Diqqət",
                        message: "Hesabınıza başqa cihazdan giriş edilib. Çıxış edilir.",
                        type: "error",
                    });

                    localStorage.clear();
                    navigate("/sifaris/login", {
                        replace: true
                    });
                    return;
                }

                if (!u.phoneId || u.phoneId !== stableDeviceId) {
                    try {
                        await updateUser(storedUserId, {
                            phoneId: stableDeviceId,
                            platform: "web",
                        });
                    } catch (e) {
                        console.log("phoneId update error:", e?.message);
                    }
                }

                setUsername(u.name || "");
                localStorage.setItem("phoneNumber", String(u.phoneNumber || ""));

                const groupResp = await getChatGroupById(1);
                const mutedList = Array.isArray(groupResp?.data?.mutedUserIds)
                ? groupResp.data.mutedUserIds.map(Number): [];

                setIsMuted(mutedList.includes(Number(storedUserId)));

                const [me,
                    group] = await Promise.all([
                        getCustomUser(storedUserId),
                        getChatGroupById(1)
                    ]);

                userCacheRef.current = me?.data;
                groupCacheRef.current = group?.data;

                await getAllChats();
                await fetchTodayStats();
                ensureWebSocket();
            } catch (e) {
                console.log("OrderGroup init error:", e?.message);
            }
        };

        initialize();
    },
        [ensureWebSocket,
            getAllChats]);

    useEffect(() => {
        safeScrollToBottom(true);
    },
        [chatMessages.length,
            safeScrollToBottom]);

    useEffect(() => {
        const lastClickedTime = localStorage.getItem("lastClickedTime");
        if (!lastClickedTime) return;

        const currentTime = Date.now();
        const timeDiff = currentTime - Number(lastClickedTime);

        if (timeDiff < 60000) {
            setCanClickZinqirov(false);

            const remainingTime = 60000 - timeDiff;
            const timer = setTimeout(() => {
                setCanClickZinqirov(true);
            }, remainingTime);

            return () => clearTimeout(timer);
        } else {
            setCanClickZinqirov(true);
        }
    },
        []);

    useEffect(() => {
        return () => {
            if (scrollTimerRef.current) {
                clearTimeout(scrollTimerRef.current);
            }
        };
    },
        []);


    const handleMessagesScroll = useCallback((e) => {
        const currentTop = e.currentTarget.scrollTop;
        const diff = currentTop - lastScrollTopRef.current;

        if (Math.abs(diff) > 6) {
            setShowQuickNav(false);
        }

        lastScrollTopRef.current = currentTop;

        if (scrollTimerRef.current) {
            clearTimeout(scrollTimerRef.current);
        }

        scrollTimerRef.current = setTimeout(() => {
            setShowQuickNav(true);
        }, 140);
    },
        []);


    useEffect(() => {
        const handleVisibility = () => {
            if (document.visibilityState === "visible") {
                socketReadyRef.current = false;
                ensureWebSocket();
            }
        };

        document.addEventListener("visibilitychange", handleVisibility);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibility);
        };
    },
        [ensureWebSocket]);


    const sendPushNotification = async (ids,
        messageTitle,
        messageBody) => {
        const subs = (Array.isArray(ids) ? ids: [ids])
        .map((x) => String(x || "").trim())
        .filter(isValidUUID);

        const uniqueSubs = [...new Set(subs)];

        if (!uniqueSubs.length) {
            console.log("Push skipped: no valid subscription ids");
            return;
        }

        try {
            const response = await axios.post(
                "https://onesignal.com/api/v1/notifications",
                {
                    app_id: ONE_SIGNAL_APP_ID,
                    include_subscription_ids: uniqueSubs,
                    headings: {
                        en: messageTitle
                    },
                    contents: {
                        en: messageBody
                    },
                    android_channel_id: "66708726-e8b4-4b02-b8db-4c8343046b23",
                    data: {
                        screen: "OrderGroup",
                        groupId: 1,
                    },
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Basic ${ONE_SIGNAL_REST_API_KEY}`,
                    },
                }
            );

            console.log("Push bildirişi uğurla göndərildi:", response.data);
        } catch (error) {
            console.error(
                "Push bildirimi göndərmə xətası:",
                error?.response?.data || error?.message
            );
        }
    };

    const resendPushNotification = async (message) => {
        try {
            const users = await getUsers();
            if (!users?.data) return;

            const groupResp = await getChatGroupById(1);
            const mutedList = Array.isArray(groupResp?.data?.mutedUserIds)
            ? groupResp.data.mutedUserIds.map(Number): [];

            const oneSignalIds = users.data
            .filter(
                (u) =>
                Number(u.id) !== Number(userId) &&
                !u.userType?.includes("customer") &&
                !mutedList.includes(Number(u.id)) &&
                !!u.oneSignal &&
                hasActiveSubscription(u)
            )
            .map((u) => u.oneSignal)
            .filter(Boolean);

            if (!oneSignalIds.length) {
                showMessage( {
                    title: "Diqqət",
                    message: "Bildirim göndəriləcək istifadəçi yoxdur.",
                    type: "warning",
                });
                return;
            }

            await sendPushNotification(
                oneSignalIds,
                "🔄 Yeni Təkrar Bildiriş!",
                `📩 ${message.username}: ${message.message}`
            );

            showMessage( {
                title: "Uğurlu",
                message: "Mesajın bildirişi uğurla yenidən göndərildi.",
                type: "success",
            });
        } catch (error) {
            console.error("Push bildirimi yenidən göndərərkən xəta:", error);
            showMessage( {
                title: "Xəta",
                message: "Bildirişi yenidən göndərmək mümkün olmadı.",
                type: "error",
            });
        }
    };

    useEffect(() => {
        const timer = setInterval(() => {
            completeIfExpired(chatMessages);
        }, 30000);

        return () => clearInterval(timer);
    }, [chatMessages, completeIfExpired]);

    const handleClickZinqirov = async (message) => {
        if (!canClickZinqirov) {
            showMessage( {
                title: "Dəqiqlik",
                message:
                "Hər 1 dəqiqədə sadəcə bir dəfə yenidən bildiriş göndərə bilərsiniz.",
                type: "warning",
            });
            return;
        }

        const currentTime = Date.now();
        localStorage.setItem("lastClickedTime", String(currentTime));
        setCanClickZinqirov(false);

        setTimeout(() => {
            setCanClickZinqirov(true);
        }, 60000);

        await resendPushNotification(message);
    };

    const editMessageAndResendPushNotification = async (message, newText) => {
        try {
            const users = await getUsers();
            if (!users?.data) return;

            const groupResp = await getChatGroupById(1);
            const mutedList = Array.isArray(groupResp?.data?.mutedUserIds)
            ? groupResp.data.mutedUserIds.map(Number): [];

            const oneSignalIds = users.data
            .filter(
                (u) =>
                Number(u.id) !== Number(userId) &&
                !u.userType?.includes("customer") &&
                !mutedList.includes(Number(u.id)) &&
                !!u.oneSignal &&
                hasActiveSubscription(u)
            )
            .map((u) => u.oneSignal)
            .filter(Boolean);

            if (!oneSignalIds.length) return;

            sendPushNotification(
                oneSignalIds,
                "🔄 Sifariş Dəyişdirildi!",
                `📩 ${message.username}: ${newText}`
            );
        } catch (error) {
            console.error("Push bildirimi yenidən göndərərkən xəta:", error);
        }
    };



    const handleSendMessage = async () => {
        if (!currentMessage.trim()) return;

        const uid = localStorage.getItem("id");
        const uResp = await getCustomUser(uid);
        const phone = String(uResp?.data?.phoneNumber || myPhone || "");

        const newChat = {
            id: Date.now(),
            groupId: "1",
            userId: Number(uid),
            username,
            phone,
            messageType: "text",
            isReply: "false",
            userType: userType || "customer",
            message: currentMessage,
            timestamp: moment().tz("Asia/Baku").format("YYYY-MM-DD HH:mm:ss"),
            isCompleted: false,
            isSeenIds: [],
        };

        sendMessageToSocket(newChat);
        setCurrentMessage("");
        safeScrollToBottom(true);
        playSendSound();

        try {
            const users = await getUsers();
            const groupResp = await getChatGroupById(1);
            const mutedList = Array.isArray(groupResp?.data?.mutedUserIds)
            ? groupResp.data.mutedUserIds.map(Number): [];

            const oneSignalIds = (users?.data || [])
            .filter((u) => Number(u.id) !== Number(uid))
            .filter((u) => !u.userType?.includes("customer"))
            .filter((u) => !mutedList.includes(Number(u.id)))
            .filter((u) => !!u.oneSignal)
            .filter((u) => hasActiveSubscription(u))
            .map((u) => u.oneSignal)
            .filter(Boolean);

            if (oneSignalIds.length) {
                sendPushNotification(
                    oneSignalIds,
                    "🪄🪄 Yeni Sifariş!!",
                    `📩 ${username}: ${newChat.message}`
                );
            }
        } catch (error) {
            console.error("Push bildirimi gönderirken hata oluştu:", error);
        }
    };

    const startEditingMessage = (message) => {
        setEditingMessage(message);
        setEditedText(message.message);
    };

    const handleUpdateMessage = async () => {
        if (!editedText.trim() || !editingMessage) return;

        try {
            setIsUpdating(true);

            await updateChat(editingMessage.id, {
                message: editedText
            });

            setChatMessages((prev) =>
                prev.map((msg) =>
                    msg.id === editingMessage.id ? {
                        ...msg, message: editedText
                    }: msg
                )
            );

            await editMessageAndResendPushNotification(editingMessage, editedText);

            setIsUpdating(false);
            setEditingMessage(null);
        } catch (error) {
            console.error("Mesajı yenilərkən xəta:", error);
            setIsUpdating(false);
        }
    };

    const handleCompleteOrder = async (messageId) => {
        try {
            const chatData = await getCustomChat(messageId);
            if (!chatData?.data) return;

            const updatedData = {
                ...chatData.data,
                isCompleted: true,
            };

            await updateChat(messageId, updatedData);

            setChatMessages((prev) =>
                prev.map((msg) =>
                    msg.id === messageId ? {
                        ...msg, isCompleted: true
                    }: msg
                )
            );
        } catch (error) {
            console.error("Siparişi tamamlarken hata oluştu:", error);
        }
    };

    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const getMessageTimeValue = (m) => {
        const raw = m?.timestamp || m?.createdAt;

        const strict = moment(raw, TS_FMT, true);
        if (strict.isValid()) return strict.valueOf();

        const loose = moment(raw);
        if (loose.isValid()) return loose.valueOf();

        return 0;
    };

    const resolveChatForAccept = async (messageOrId) => {
        const clickedMessage =
        typeof messageOrId === "object" && messageOrId !== null
        ? messageOrId: null;

        const clickedId = clickedMessage?.id ?? messageOrId;

        // 1) Əvvəl birbaşa ID ilə yoxla
        if (clickedId) {
            try {
                const directResp = await getCustomChat(clickedId);
                if (directResp?.data) {
                    return {
                        id: directResp.data.id ?? clickedId,
                        data: directResp.data,
                        fromServer: true,
                    };
                }
            } catch (e) {
                console.log("Direct getCustomChat failed:", e?.message);
            }
        }

        // 2) Canlı gələn mesaj serverə gec düşə bilər.
        // Ona görə 3 dəfə serverdən son mesajları çəkib oxşar mesajı tapırıq.
        for (let attempt = 0; attempt < 3; attempt += 1) {
            try {
                if (attempt > 0) {
                    await sleep(500);
                }

                const resp = await getChats({
                    limit: 80, groupIds: "0,1"
                });
                const list = Array.isArray(resp?.data) ? resp.data: [];

                const byId = list.find((m) => String(m.id) === String(clickedId));

                if (byId) {
                    return {
                        id: byId.id,
                        data: byId,
                        fromServer: true,
                    };
                }

                if (clickedMessage) {
                    const clickedTime = getMessageTimeValue(clickedMessage);

                    const matched = list.find((m) => {
                        const sameGroup =
                        String(m.groupId || "") === String(clickedMessage.groupId || "");

                        const sameUser =
                        String(m.userId || "") === String(clickedMessage.userId || "");

                        const sameMessage =
                        String(m.message || "").trim() ===
                        String(clickedMessage.message || "").trim();

                        const samePhone =
                        String(m.phone || "") === String(clickedMessage.phone || "");

                        const serverTime = getMessageTimeValue(m);
                        const closeTime =
                        clickedTime && serverTime
                        ? Math.abs(serverTime - clickedTime) <= 20000: true;

                        return sameGroup && sameUser && sameMessage && samePhone && closeTime;
                    });

                    if (matched) {
                        return {
                            id: matched.id,
                            data: matched,
                            fromServer: true,
                        };
                    }
                }
            } catch (e) {
                console.log("resolveChatForAccept retry error:", e?.message);
            }
        }

        // 3) Ən son fallback: canlı mesajın öz datası ilə davam et
        if (clickedMessage) {
            return {
                id: clickedId,
                data: clickedMessage,
                fromServer: false,
            };
        }

        return null;

    };

    const openWhatsAppLink = (phoneNumber, text = "+") => {
        const encodedText = encodeURIComponent(text);
        const ua = navigator.userAgent || "";

        const isAndroid = /Android/i.test(ua);
        const isIOS = /iPhone|iPad|iPod/i.test(ua);
        const isMobile = isAndroid || isIOS;

        const deepLink = `whatsapp://send?phone=${phoneNumber}&text=${encodedText}`;
        const webLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedText}`;

        if (isMobile) {
            window.location.href = deepLink;

            setTimeout(() => {
                if (!document.hidden) {
                    window.location.href = webLink;
                }
            },
                1800);

            return;
        }

        const opened = window.open(webLink,
            "_blank",
            "noopener,noreferrer");

        if (!opened) {
            window.location.href = webLink;
        }
    };
    const acceptingIdsRef = useRef(new Set());

    const handleAcceptOrder = async (messageOrId) => {
        const hasSub = await ensureCourierSubOrShowModal();
        if (!hasSub) return;
        const messageId =
        typeof messageOrId === "object" && messageOrId !== null
        ? messageOrId.id: messageOrId;

        if (acceptingIdsRef.current.has(messageId)) return;
        acceptingIdsRef.current.add(messageId);

        try {
            const courierId = localStorage.getItem("id");
            if (!courierId) {
                alert("İstifadəçi tapılmadı.");
                return;
            }

            const courierIdStr = String(courierId);

            const meResp = await getCustomUser(courierIdStr);
            const me = meResp?.data;

            if (!me) {
                alert("İstifadəçi məlumatı tapılmadı.");
                return;
            }

            if (me?.courierStatus === "active") {
                alert("Sorğunuz göndərilib, təsdiqlənməyini gözləyin.");
                return;
            }

            if (me?.courierStatus !== "accept") {
                navigate("/sifaris/waiting-room");
                return;
            }

            const resolvedChat = await resolveChatForAccept(messageOrId);

            if (!resolvedChat?.data) {
                alert("Sifariş tapılmadı, yenidən cəhd edin.");
                await getAllChats();
                return;
            }

            const msg = resolvedChat.data;
            const realMessageId = resolvedChat.id;

            if (msg.acceptedBy && String(msg.acceptedBy) !== courierIdStr) {
                alert("Bu sifariş artıq qəbul edilib.");
                return;
            }

            if (msg.isCompleted) {
                alert("Sifariş tamamlanıb.");
                return;
            }

            await updateChat(realMessageId, {
                ...msg,
                acceptedBy: courierIdStr,
                acceptedAt: moment().tz("Asia/Baku").format(TS_FMT)
            });

            const phoneNumber = msg.phone;

            if (!phoneNumber) {
                alert("Nömrə yoxdur.");
                return;
            }

            const formatted = formatPhoneNumberForWhatsApp(phoneNumber);
            openWhatsAppLink(formatted, "+");

        } catch (e) {
            console.error(e);
            alert("Xəta baş verdi.");
        } finally {
            acceptingIdsRef.current.delete(messageId);
        }
    };

    const handleContactAdmin = () => {
        const adminPhoneNumber = "0709559984";
        const formattedPhoneNumber = formatPhoneNumberForWhatsApp(adminPhoneNumber);
        const whatsappUrl = `https://wa.me/${formattedPhoneNumber}?text=${encodeURIComponent(
            "Salam, "
        )}`;

        window.open(whatsappUrl, "_blank");
    };

    const handleLogout = async () => {
        setLogoutMenuOpen(true);
    };

    const handleSwitchToCustomer = async () => {
        try {
            const uid = localStorage.getItem("id");
            if (!uid) return;

            localStorage.setItem("userType", "customer");
            localStorage.removeItem("courierType");

            await updateUser(uid, {
                userType: "customer"
            });

            setUserType("customer");
            setCourierType("");
            setLogoutMenuOpen(false);

            showSwitchSuccess("Müştəri hesabına keçildi.");
        } catch (e) {
            console.error("handleSwitchToCustomer error:", e);
        }
    };

    const handleSwitchToCourier = async () => {
        try {
            await openCourierTypeSelection();
        } catch (e) {
            console.error("handleSwitchToCourier error:", e);
        }
    };

    const handleFullLogout = async () => {
        try {
            localStorage.clear();
            setLogoutMenuOpen(false);
            navigate("/sifaris/login", {
                replace: true
            });
        } catch (e) {
            console.error("handleFullLogout error:", e);
        }
    };



    const ensureCourierSubOrShowModal = async () => {
        const uid = localStorage.getItem("id");
        if (!uid) return false;

        const meResp = await getCustomUser(uid);
        const me = meResp?.data;

        const isCustomer =
        String(me?.userType || "").includes("customer") ||
        String(userType || "").includes("customer");

        if (isCustomer) return true;

        if (!hasActiveSubscription(me)) {
            setShowSub(true);
            return false;
        }

        return true;
    };

    const generateLocationUrl = () => {
        const randomId = Math.random().toString(36).substring(2, 12);
        return `https://mototaksi.az/location/${randomId}`;
    };

    const setSeenId = async (messageId) => {
        try {
            const uid = localStorage.getItem("id");
            if (!uid) return;

            const chatResponse = await getCustomChat(messageId);
            if (!chatResponse?.data) return;

            const chatData = chatResponse.data;

            let updatedSeenIds = Array.isArray(chatData.isSeenIds)
            ? [...chatData.isSeenIds]: [];

            if (!updatedSeenIds.includes(uid)) {
                updatedSeenIds.push(uid);
            }

            const updatedData = {
                ...chatData,
                isSeenIds: updatedSeenIds,
            };

            await updateChat(messageId, updatedData);
        } catch (error) {
            console.error("setSeenId error:", error);
        }
    };

    const openCourierTypeSelection = async () => {
        setLogoutMenuOpen(false);
        setCourierTypeModalOpen(true);
    };

    const playSendSound = useCallback(() => {
        try {
            if (!sendAudioRef.current) {
                sendAudioRef.current = new Audio("/send_msg.mp3");
            }

            sendAudioRef.current.currentTime = 0;
            sendAudioRef.current.play().catch(() => {});
        } catch (e) {
            console.log("playSendSound error:", e?.message);
        }
    },
        []);

    const handleSelectMotoCourier = async () => {
        try {
            const uid = localStorage.getItem("id");
            if (!uid) return;

            localStorage.setItem("courierType", "moto");
            localStorage.setItem("userType", "courier");

            await updateUser(uid, {
                userType: "moto_courier"
            });

            setCourierType("moto");
            setUserType("courier");
            setCourierTypeModalOpen(false);

            showSwitchSuccess("Moto kuryer hesabına keçildi.");
        } catch (e) {
            console.error("handleSelectMotoCourier error:", e);
        }
    };

    const handleSelectCarCourier = async () => {
        try {
            const uid = localStorage.getItem("id");
            if (!uid) return;

            localStorage.setItem("courierType", "car");
            localStorage.setItem("userType", "courier");

            await updateUser(uid, {
                userType: "car_courier"
            });

            setCourierType("car");
            setUserType("courier");
            setCourierTypeModalOpen(false);

            showSwitchSuccess("Maşın kuryer hesabına keçildi.");
        } catch (e) {
            console.error("handleSelectCarCourier error:", e);
        }
    };



    const toggleMute = async () => {
        try {
            const uid = localStorage.getItem("id");
            const numUid = Number(uid);

            const groupResp = await getChatGroupById(1);
            const currentList = Array.isArray(groupResp?.data?.mutedUserIds)
            ? groupResp.data.mutedUserIds.map(Number): [];

            const isCurrentlyMuted = currentList.includes(numUid);

            const nextList = isCurrentlyMuted
            ? currentList.filter((id) => id !== numUid): [...currentList,
                numUid];

            await updateChatGroup(1, {
                mutedUserIds: nextList
            });
            setIsMuted(!isCurrentlyMuted);
        } catch (error) {
            console.error("Bildiriş vəziyyəti dəyişdirilərkən xəta:", error);
        }
    };


    const messagesWithAds = chatMessages;

    const listData = useMemo(
        () => groupMessagesByDate(messagesWithAds),
        [messagesWithAds]
    );

    return (


        <div className="sq-order-page">
            <div
                className="sq-order-bg"
                style={ { backgroundImage: "url(/background.png)" }}
                >

                <div className="sq-order-header">
                    <div className="sq-order-header-left">
                        <h1 className="sq-order-header-title">Sifarişlər</h1>
                    </div>

                    <div className="sq-order-header-buttons">
                        <button type="button" className="sq-mute-btn" onClick={toggleMute}>
                            {isMuted ? "🔊 Səsi aç": "🔕 Səsi bağla"}
                        </button>

                        <button
                            type="button"
                            className="sq-icon-header-btn"
                            onClick={() => navigate("/sifaris/notification")}
                            >
                            <IoNotificationsOutline size={20} color="#fff" />
                        </button>

                        <button
                            type="button"
                            className="sq-icon-header-btn"
                            onClick={() => navigate("/sifaris/settings")}
                            >
                            <IoSettingsOutline size={20} color="#fff" />
                        </button>


                        <button type="button" className="sq-logout-btn" onClick={handleLogout}>
                            <IoLogOutOutline size={18} color="#fff" />
                            <span>Çıxış</span>
                        </button>
                    </div>
                </div>

                <TodayOrdersBanner
                    count={todayTotalCount}
                    />

                <div className="sq-messages-list" onScroll={handleMessagesScroll}>
                    {listData.map((section) => (
                        <div key={section.id}>
                            <div className="sq-date-badge-container">
                                <div className="sq-date-badge-text">
                                    {section.title}
                                </div>
                            </div>

                            {section.data?.map((message) => (
                                <div
                                    key={message.id}
                                    className="sq-message-container sq-other-message"
                                    >
                                    <div
                                        className={`sq-message-user ${
                                        message.userId === 0 && message.userType === "admin"
                                        ? "sq-admin-username": ""
                                        }`}
                                        >
                                        {message.username}
                                    </div>

                                    {/* LOCATION / TEXT */}
                                    {String(
                                        message.messageType || message.type || ""
                                    ).toLowerCase() === "location" ||
                                    (Number.isFinite(
                                        Number(message.locationLat ?? message.lat ?? message.latitude)
                                    ) &&
                                        Number.isFinite(
                                            Number(message.locationLng ?? message.lng ?? message.longitude)
                                        )) ? (
                                        <LocationBubble message={message} />
                                    ): (
                                        <div className="sq-message-text">
                                            {String(message.message || "")
                                            .split(" ")
                                            .map((word, index, arr) => {
                                                const phoneNumber = detectPhoneNumber(word);

                                                return phoneNumber ? (
                                                    <a
                                                        key={index}
                                                        className="sq-phone-link"
                                                        href={`https://wa.me/${formatPhoneNumberForWhatsApp(
                                                            phoneNumber
                                                        )}`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        >
                                                        {phoneNumber}
                                                        {index < arr.length - 1 ? " ": ""}
                                                    </a>
                                                ): (
                                                    <React.Fragment key={index}>
                                                        {word}
                                                        {index < arr.length - 1 ? " ": ""}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </div>
                                    )}

                                    <div className="sq-timestamp">
                                        {toAzMoment(
                                            message.timestamp || message.createdAt
                                        ).format("HH:mm")}
                                    </div>

                                    {/* STATUS BUTTONS */}
                                    {message.isCompleted ? (
                                        <div className="sq-completed-order-container">
                                            <div className="sq-completed-order-text">
                                                Sifariş Tamamlandı
                                            </div>
                                        </div>
                                    ): !["0", "1"].includes(String(message.groupId)) ? null: message.userId ===
                                    0 && message.userType === "admin" ? (
                                        <button
                                            type="button"
                                            className="sq-contact-button"
                                            onClick={handleContactAdmin}
                                            >
                                            📞 Əlaqə
                                        </button>
                                    ): userType === "customer" ? (
                                        message.userId === userId ? (
                                            <button
                                                type="button"
                                                className="sq-accept-button"
                                                onClick={() => handleCompleteOrder(message.id)}
                                                >
                                                Sifarişi Tamamla
                                            </button>
                                        ): null
                                    ): (
                                        <button
                                            type="button"
                                            className="sq-accept-button"
                                            onClick={() => handleAcceptOrder(message)}
                                            disabled={acceptingIdsRef.current.has(message.id)}
                                            >
                                            Sifarişi Qəbul Et
                                        </button>
                                    )}

                                    {/* MINI ACTIONS */}
                                    {!message.isCompleted &&
                                    String(message.groupId) === "1" &&
                                    userType === "customer" &&
                                    message.userId === userId && (
                                        <>
                                            <button
                                                type="button"
                                                className="sq-bell-mini-btn"
                                                onClick={() => handleClickZinqirov(message)}
                                                disabled={!canClickZinqirov}
                                                >
                                                🔔
                                            </button>

                                            <button
                                                type="button"
                                                className="sq-edit-mini-btn"
                                                onClick={() => startEditingMessage(message)}
                                                >
                                                ✏️
                                            </button>
                                        </>
                                    )}
                                </div>
                            ))}
                        </div>
                    ))}

                    <div ref={bottomRef} />
                </div>

                <QuickNav visible={showQuickNav} />

                {userType === "customer" && (
                    <div className="sq-input-container">
                        <textarea
                            className="sq-text-input"
                            placeholder="Sifarişinizi qeyd edin..."
                            value={currentMessage}
                            maxLength={2000}
                            onChange={(e) => setCurrentMessage(e.target.value)}
                            rows={3}
                            />

                        <button
                            type="button"
                            className="sq-send-button"
                            onClick={handleSendMessage}
                            >
                            Göndər
                        </button>
                    </div>
                )}
            </div>

            <EditMessageModal
                open={!!editingMessage}
                editedText={editedText}
                setEditedText={setEditedText}
                onCancel={() => setEditingMessage(null)}
                onSubmit={handleUpdateMessage}
                loading={isUpdating}
                />

            {messageModal.open && (
                <div className="sq-modal-overlay">
                    <div className="sq-alert-modal">
                        <h3 className={`sq-alert-title sq-alert-${messageModal.type}`}>
                            {messageModal.title}
                        </h3>
                        <p className="sq-alert-message">
                            {messageModal.message}
                        </p>
                        <button
                            type="button"
                            className="sq-alert-button"
                            onClick={() =>
                            setMessageModal((prev) => ({ ...prev, open: false }))
                            }
                            >
                            Bağla
                        </button>
                    </div>
                </div>
            )}

            {imagePreview.visible && (
                <div className="sq-preview-backdrop" onClick={closeImagePreview}>
                    <div
                        className="sq-preview-content"
                        onClick={(e) => e.stopPropagation()}
                        >
                        <img
                        src={imagePreview.uri}
                        alt="Preview"
                        className="sq-preview-image"
                        />

                    <button
                        type="button"
                        className="sq-preview-close"
                        onClick={closeImagePreview}
                        >
                        ✕
                    </button>
                </div>
            </div>
        )}

        {logoutMenuOpen && (
            <div className="sq-modal-overlay">
                <div className="sq-logout-modal">
                    <h3 className="sq-logout-title">Çıxış</h3>
                    <p className="sq-logout-text">
                        Hesabınızdan çıxış etmək istədiyinizə əminsiniz?
                    </p>

                    {!String(userType || "").includes("customer") && (
                        <button
                            type="button"
                            className="sq-logout-option-btn"
                            onClick={handleSwitchToCustomer}
                            >
                            Müştəri hesabına giriş et
                        </button>
                    )}

                    {!String(userType || "").includes("courier") && (
                        <button
                            type="button"
                            className="sq-logout-option-btn"
                            onClick={handleSwitchToCourier}
                            >
                            Kuryer hesabına giriş et
                        </button>
                    )}

                    <button
                        type="button"
                        className="sq-logout-danger-btn"
                        onClick={handleFullLogout}
                        >
                        Tam çıxış et
                    </button>

                    <button
                        type="button"
                        className="sq-logout-cancel-btn"
                        onClick={() => setLogoutMenuOpen(false)}
                        >
                        İmtina et
                    </button>
                </div>
            </div>
        )}

        {courierTypeModalOpen && (
            <div className="sq-modal-overlay">
                <div className="sq-logout-modal">
                    <h3 className="sq-logout-title">Kuryer Tipini Seçin</h3>
                    <p className="sq-logout-text">
                        Zəhmət olmasa, hansı növ kuryer olmaq istədiyinizi seçin.
                    </p>

                    <button
                        type="button"
                        className="sq-logout-option-btn"
                        onClick={handleSelectMotoCourier}
                        >
                        Moto Kuryer
                    </button>

                    <button
                        type="button"
                        className="sq-logout-option-btn"
                        onClick={handleSelectCarCourier}
                        >
                        Maşın Kuryer
                    </button>

                    <button
                        type="button"
                        className="sq-logout-cancel-btn"
                        onClick={() => setCourierTypeModalOpen(false)}
                        >
                        İmtina et
                    </button>
                </div>
            </div>
        )}

        {switchSuccessModal.open && (
            <div className="sq-modal-overlay">
                <div className="sq-alert-modal">
                    <h3 className="sq-alert-title sq-alert-success">Uğurlu</h3>
                    <p className="sq-alert-message">
                        {switchSuccessModal.message}
                    </p>

                    <button
                        type="button"
                        className="sq-alert-button"
                        onClick={() => {
                            setSwitchSuccessModal({ open: false, message: "" });
                            navigate("/sifaris/order-group", { replace: true });
                        }}
                        >
                        Davam et
                    </button>
                </div>
            </div>
        )}

        {userType && !String(userType).includes("customer") && showSub && (
            <SubModal />
        )}
    </div>
);
};

export default OrderGroupScreen;
